"use client"

import { useState, useEffect } from "react"
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Monitor, Map } from "lucide-react"

export function MobileNotice() {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth < 768
      setIsMobile(isMobileDevice)
      // Only show notice on first visit
      const hasSeenNotice = localStorage.getItem("hasSeenMobileNotice") === "true"
      setIsOpen(isMobileDevice && !hasSeenNotice)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  if (!isMobile) return null

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[calc(100%-32px)] max-w-sm bg-white rounded-lg shadow-lg">
        <div className="p-6 space-y-4">
          <AlertDialogHeader className="space-y-4">
            <AlertDialogTitle className="flex items-center justify-center gap-2 text-xl">
              <Map className="h-6 w-6" />
              <span>Welcome to Coverage Maps</span>
            </AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-4 text-sm text-muted-foreground">
                <div className="p-4 bg-blue-50 rounded-lg">
                  <span className="text-sm text-blue-900">
                    Our coverage maps tool is fully functional on mobile devices. For the best experience with larger
                    maps, you might prefer a desktop view.
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2 text-sm font-medium text-gray-600">
                  <Monitor className="h-6 w-6 text-blue-500" />
                  <span>Tip: Use landscape mode for better viewing</span>
                </div>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div className="mt-4">
            <Button
              className="w-full py-2 text-base font-medium"
              onClick={() => {
                setIsOpen(false)
                localStorage.setItem("hasSeenMobileNotice", "true")
              }}
            >
              Got it
            </Button>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  )
}
